<div class="progress">
  @if (!uploadProgressService.isCompleted()) {
    <div class="progress-info">
      <progress
        class="progress-bar"
        [value]="uploadProgressService.currentProgress()"
        max="100"
      ></progress>
      <span>
        {{uploadProgressService.currentProgress()}}%
      </span>
    </div>
  } @else {
    <div class="upload-complete">
      Файл загружен!
    </div>
  }
</div>
